var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-btn"},[(_vm.title)?_c('div',{staticClass:"defaults-btn",on:{"click":_vm.submit}},[_c('p',[_vm._v(_vm._s(_vm.title))]),_vm._t("icon")],2):_vm._t("btn")],2)}
var staticRenderFns = []

export { render, staticRenderFns }